<div
  class="min-h-screen flex items-center justify-center bg-[url('/assets/images/login-bg-image.webp')] bg-cover bg-center w-full relative px-4 pt-20 lg:pt-0">

  <!-- Top right logo (desktop only) -->
  <div>
    <img src="assets/images/logo-page-top.webp" class="hidden lg:block absolute -top-15 right-0 w-[458px] h-[136px]">
  </div>

  <!-- Main Logo (responsive) -->
  <div class="
      absolute top-6 left-1/2 -translate-x-1/2
      transition-all duration-300
      lg:left-10 lg:translate-x-0
    ">
    <img src="assets/images/logo.svg" alt="" class="w-35 md:w-36 lg:w-48 h-auto">
  </div>

  <!-- White form card -->
  <div class="w-full max-w-[360px] min-h-[355px] relative      
   lg:top-25
   ms-auto
   mt-13
   lg:-mt-40
   lg:right-30 z-40">
    <div class="
      bg-white rounded-4xl  
     p-6
    ">
      <img src="assets/images/login-drops.webp" class="absolute h-20 -top-8 -left-25">

      <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="space-y-4">
        <img src="assets/images/signin.webp" class="h-7 w-[90px] mb-6 mx-auto lg:mx-0" alt="">

        <div class="w-full">
          <label class="text-sm">Enter your Email</label>
          <input type="text" formControlName="email" placeholder="Enter your Email"
            class="w-full px-4 py-4 mt-1 rounded-lg h-11 bg-bg placeholder-text-muted focus:outline-none focus:ring-2 focus:ring-red-500" />
          @if (loginForm.get('email')?.invalid && loginForm.get('email')?.touched) {
          <p class="text-red-500 text-sm mt-1">Email is required</p>
          }
        </div>

        <div class="w-full">
          <label class="text-sm">Enter your Password</label>
          <input type="password" formControlName="password" placeholder="Enter your Password"
            class="w-full px-4 py-4 mt-1 rounded-lg h-11 bg-bg placeholder-text-muted focus:outline-none focus:ring-2 focus:ring-red-500" />
          @if (loginForm.get('password')?.invalid && loginForm.get('password')?.touched) {
          <p class="text-red-500 text-sm mt-1">Password is required</p>
          }
        </div>

        @if (errorMessage()) {
        <div class="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg text-sm">
          {{ errorMessage() }}
        </div>
        }

        <app-button type="submit" [disabled]="isLoading() || loginForm.invalid" [loading]="isLoading()" label="Login"
          variant="primary" size="md" class="w-full"></app-button>
      </form>
    </div>

    <!-- Flowers (desktop only) -->
    <div class="hidden lg:block h-[175px] -z-10 overflow-hidden w-[160px] absolute -right-20 -bottom-10">
      <img src="assets/images/login-form-flowers.webp" alt="">
    </div>
  </div>
</div>